export default {
    api: {
        baseUrl: process.env.REACT_APP_API_URL,
    },
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/base.ts